<template>
  <TemplateTable
    :title="$t('menu.recom_tradein-articles')"
    :text="$t('recom_tradein-articles.description')"
    name="recomTradeinArticles"
    :url="$listRoutes.recomTradeinArticles"
    :table="recomTradeinArticles"
    :filters="recomTradeinArticlesFilters"
    :filtersWording="filtersWording"
    :fields="fields"
    :defaultFilters="defaultTableFilters"
    :requireFilters="isAdmin ? 'brand' : true"
    :useCurrency="true"
  />
</template>

<script>
import TemplateTable from '@/components/templates/TemplateTable';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'RecomTradeinArticles',
    components: {TemplateTable},
    data() {
        return {
            filtersWording: {
                declarer: {
                    filterTitle: this.$t('recom_articles.declarer.title'),
                    customer: this.$t('recom_articles.declarer.customer'),
                    web: this.$t('recom_articles.declarer.customer'),
                    store: this.$t('recom_articles.declarer.store'),
                    warehouse: this.$t('recom_articles.declarer.warehouse'),
                },
                channel: {
                    filterTitle: this.$t('recom_articles.declarer.title'),
                    customer: this.$t('recom_articles.declarer.customer'),
                    web: this.$t('recom_articles.declarer.customer'),
                    store: this.$t('recom_articles.declarer.store'),
                    warehouse: this.$t('recom_articles.declarer.warehouse'),
                },
                reference: {
                    filterTitle: this.$t('global.article_id')
                },
                customer: {
                    filterTitle: this.$t('global.email')
                },
                dateControl: {
                    filterTitle: this.$t('global.controlReviewCreatedAt')
                }
            },
            fields: [
                { key: 'id', type: 'eye', route: 'recom_tradein-n-sell-article', size: "xs"},
                { key: 'brand.name', type: 'client', translationKey: 'client', size: 'm' },
                { key: 'tradeInCart.customer.email', type: 'CmsCustomer', size: 'xl', translationKey: "email" },
                { key: 'reference', size: 'm', type: "copy", translationKey: "article_id"},
                { key: 'ean', size: 'm', type: "copy" },
                { key: 'sku', size: 'm', type: "copy" },
                { key: 'state', type: 'tagType', size: 'm' },
                { key: 'createdAt', size: 'l', type: 'date', translationKey: 'tradeinCreateAt'},
                { key: 'controlReview.createdAt', size: 'l', type: 'date', translationKey:'controlReviewCreatedAt'},
                { key: 'creditedAt', type: 'date', translationKey: 'dateCredit', size: 'm'},
                { key: 'initialReview.condition', type: 'tagType', translation: "global.creditReviewCondition" },
                { key: 'controlReview.condition', type: 'tagType', size: 'm' },
                { key: 'initialReview.price', type: 'formatPrice', translationKey: 'purposed_price', size: 'm' },
                { key: 'priceCredit', type: 'formatPrice', translationKey: 'credit_price', size: 'm' },
                { key: 'priceResale', type: 'formatPrice', translationKey: 'priceResaleBeforeDiscount', size: 'm' },
                { key: 'discountedPrice', type: 'formatPriceDiscounted', translationKey: 'priceResaleAfterDiscount', size: 'm' },
                { key: 'tradeInCart.channel', translationKey: 'articleSource', type: 'tagType', size: 'm' },
                { key: 'tradeInCart.customer.profile', type: 'tagType', size: 'm' },
                { key: 'tradeInCart.customer.countryCode', translationKey: "countries_code", type: 'country'}
            ]
        }
    },
    computed: {
        ...mapState(['recomTradeinArticles', 'recomTradeinArticlesFilters', 'clientsCms']),
        ...mapGetters(['isAdmin']),
        defaultTableFilters() {
            const date = new Date();
            date.setDate(date.getDate() - 120);
            const filters = [`dateControl[gte]=${date.toISOString().split('T')[0]}`];

            if (this.isAdmin) {
                const brandFilter = this.recomTradeinArticlesFilters?.find((filter) => filter.key === 'brand');
                const activeBrandIds = new Set((this.clientsCms || []).map(c => c.id));
                const filteredBrands = brandFilter?.options?.filter(opt => activeBrandIds.has(opt.id)) || [];
                const firstBrand = filteredBrands[0];
                const firstBrandId = typeof firstBrand === 'object' ? firstBrand?.id : firstBrand;

                if (firstBrandId !== undefined && firstBrandId !== null && firstBrandId !== '') {
                    filters.push(`brand[in]=${encodeURIComponent(firstBrandId)}`);
                }
            }

            return filters.join('&');
        },
    }
}
</script>
